module.exports = __webpack_public_path__ + "static/media/homepageBg1.41ce6e6d.jpg";